<template>
  <div>
    <NBar title="帐号设置"/>
    <!--    <div class="accounts">-->
    <!--      <nut-cell :show-icon="true" title="刘勃鹏" sub-title="18507315674">-->
    <!--        <div slot="avatar"><img class="img-icon" :src='require("@/resource/img/device/headImg.png")'/></div>-->
    <!--        <nut-icon type="tick" slot="icon" size="15px" color="#577af6"></nut-icon>-->
    <!--      </nut-cell>-->
    <!--      <nut-cell :show-icon="false" title="刘勃鹏" sub-title="18507315674">-->
    <!--        <div slot="avatar"><img class="img-icon" :src='require("@/resource/img/device/headImg.png")'/></div>-->
    <!--      </nut-cell>-->
    <!--      <nut-cell :show-icon="true" style="background-size: 100% 0;">-->
    <!--        <span slot="title" class="cell-title-btn">删除账号</span>-->
    <!--        <div slot="desc" class="cell-desc-btn" @click="addAccount()">-->
    <!--          <nut-icon type="plus" size="12px" color="#577af6" class="plus-icon"/>-->
    <!--          <span>添加账号</span>-->
    <!--        </div>-->
    <!--      </nut-cell>-->
    <!--      <nut-dialog title="添加账号信息" :visible="dialogShow" @ok-btn-click="dialogShow=false"-->
    <!--                  @cancel-btn-click="dialogShow=false" @close="dialogShow=false"-->
    <!--                  okBtnTxt="登录">-->
    <!--        <div class="top-tip">-->
    <!--          <p>用户须知</p>-->
    <!--          <span>1.本功能仅适用于同一个商户多个登陆账号的切换。举例：用户登陆A账号时，添加关联B账号后，可以从A账户切换到B账号，无需输入账号密码。但为了保障信息安全，登陆B账号时，必须由B再添加关联A账号，才能做到今后的互相切换。</span>-->
    <!--          <span>2.请妥善保管账号密码。如需临时添加他人账号，请务必退出账号后再登陆。</span>-->
    <!--        </div>-->
    <!--        <nut-textinput v-model="account" label="账号：" placeholder="请输入账号" style="margin-bottom: 10px;" :clearBtn="true"-->
    <!--                       :disabled="false"/>-->
    <!--        <nut-textinput placeholder="请输入密码" v-model="pwd" label="密码：" type="password"/>-->
    <!--      </nut-dialog>-->
    <!--    </div>-->
    <div class="title">消息通知设置</div>
    <nut-cell :show-icon="true" title="接收消息的微信" @click-cell="msgWeChat()" style="margin: 0px 15px;border-radius: 5px;">
    </nut-cell>
    <div class="title">即时推送</div>
    <div class="cell">
      <div class="cell-top">
        <span>设备离线消息</span>
        <nut-switch :active="true" class="my-switch">
        </nut-switch>
      </div>
      <span class="text">00:00-24:00，设备离线即推送</span>
    </div>
    <div class="cell">
      <div class="cell-top">
        <span>设备故障消息</span>
        <nut-switch :active="true" class="my-switch">
        </nut-switch>
      </div>
      <span class="text">00:00-24:00，设备故障即推送</span>
    </div>
    <div class="cell">
      <div class="cell-top">
        <span>设备流控消息</span>
        <nut-switch :active="true" class="my-switch">
        </nut-switch>
      </div>
      <span class="text">00:00-24:00，设备故障即推送</span>
    </div>
    <div class="title">汇总推送</div>
    <div class="cell">
      <div class="cell-top">
        <span>设备离线消息</span>
        <nut-switch :active="true" class="my-switch">
        </nut-switch>
      </div>
      <span class="text">9:00~21:00，每隔3小时推送一次</span>
    </div>
    <div class="cell">
      <div class="cell-top">
        <span>设备故障消息</span>
        <nut-switch :active="true" class="my-switch">
        </nut-switch>
      </div>
      <span class="text">9:00-21:00，每隔3小时推送一次</span>
    </div>
    <div class="cell">
      <div class="cell-top">
        <span>时段收益概况</span>
        <nut-switch :active="true" class="my-switch">
        </nut-switch>
      </div>
      <span class="text">9:00-21:00，每隔3小时推送一次</span>
    </div>
    <nut-cell :show-icon="true" title="帐号与安全" @click-cell="openSecurity()"
              style="margin: 10px 15px 0 15px;border-radius: 5px;">
    </nut-cell>
    <nut-button style="margin: 15px 15px 60px 15px;border-radius: 5px;width:92%;" @click="logout">退出帐号</nut-button>
  </div>
</template>

<script>
export default {
  name: 'accountsSet',
  data () {
    return {
      dialogShow: false,
      account: '',
      pwd: ''
    }
  },
  methods: {
    addAccount () {
      this.dialogShow = true
    },
    //接收消息的微信
    msgWeChat () {
      this.$router.push('/device/MessageWeChat')
    },
    //帐号与安全
    openSecurity () {
      this.$router.push('/device/Security')
    },
    logout () {
      localStorage.removeItem('token')
      localStorage.removeItem('access_token')
      this.$router.push('/device/login')
    }
  }
}
</script>

<style scoped>
  .accounts {
    border-radius: 5px;
    margin: 5px 10px 10px 10px;
  }

  .img-icon {
    width: 50px;
    height: 50px;
    margin: 10px 10px 10px 0;
  }

  .title {
    margin: 20px 15px 5px 15px;
    color: #848484;
  }

  .top-tip {
    padding: 8px;
    box-sizing: border-box;
    background: #ffe665;
    color: #333;
    border-radius: .1rem;
    margin-bottom: .3rem;
    position: relative;
    text-align: justify;
    font-size: 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-flex: 1;
    -ms-flex: 1 0;
    flex: 1 0;
  }

  .top-tip:after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: #ffe665;
    position: absolute;
    bottom: -10px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  .cell-title-btn {
    color: #616161;
    background: #f2f2f2;
    padding: 5px 10px;
  }

  .cell-desc-btn {
    display: flex;
    align-items: center;
    color: #577af6;
    font-size: 14px;
  }

  .cell-desc-btn .plus-icon {
    padding: 4px;
    border-radius: 50%;
    border: 1px solid #577af6;
    margin-right: 5px;
  }

  .cell {
    background-color: #fff;
    margin: 0 15px;
    padding: 10px;
  }

  .cell .cell-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .cell .text {
    color: #848484;
  }

  >>> .nut-dialog-ok {
    background: #007aff;
  }

  /deep/ .my-switch.nut-switch {
    border-radius: 3px;
    border-color: #ccc;
    background-color: #ccc
  }

  /deep/ .my-switch.nut-switch .nut-switch-btn {
    border: 2px solid #fff;
    box-shadow: none;
    background-color: #fff;
    border-radius: 3px
  }

  /deep/ .my-switch.nut-switch.nut-switch-active {
    border-color: #3CD3A0;
    background-color: #3CD3A0;
  }

  /deep/ .my-switch.nut-switch.nut-switch-active .nut-switch-btn {
    background-color: #fff
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/AccountsSet.vue